import { premiumMarketMoversIndex } from '~/search-domain/indexes';
import { buildPremiumMarketMoversQuery } from '~/search-domain/pipelines/premium-market-movers/build-query';
import {
  getPremiumMarketMoversBaseFilters,
  getPremiumMarketMoversFacetAttributes,
  getPremiumMarketMoversSearchSettings,
  getPremiumMarketMoversSorting,
} from '~/search-domain/pipelines/premium-market-movers/query-config';
import { type PremiumMarketMoversSearchResponseBody } from '~/search-domain/pipelines/premium-market-movers/response-factory';
import { transformPremiumMarketMoversResponse } from '~/search-domain/pipelines/premium-market-movers/transform-response';
import { type SearchPipelineDefinition, type SearchUiState } from '~/search-domain/types';

const resolvePremiumMarketMoversSorting = () => getPremiumMarketMoversSorting();

export const premiumMarketMoversPipelineDefinition: SearchPipelineDefinition<
  SearchUiState,
  PremiumMarketMoversSearchResponseBody
> = {
  buildSearchRequest: buildPremiumMarketMoversQuery,
  facetAttributes: context => getPremiumMarketMoversFacetAttributes(context),
  getBaseFilters: () => getPremiumMarketMoversBaseFilters(),
  getSearchUiConfig: context => ({
    searchAttributes: getPremiumMarketMoversSearchSettings(context).search ?? [],
    sorting: resolvePremiumMarketMoversSorting,
  }),
  getSorting: resolvePremiumMarketMoversSorting,
  id: premiumMarketMoversIndex,
  searchSettings: context => getPremiumMarketMoversSearchSettings(context),
  transformResponse: transformPremiumMarketMoversResponse,
};
